import CoreLoadingIndicator from 'flarum/components/LoadingIndicator';

/**
 * The core implementation of the loading indicator can lead to a ghost spinner
 * That's because while the component changes, Mithril actually keeps the div
 * So the child spinner element created by spin.js stays
 */
export default class LoadingIndicator extends CoreLoadingIndicator {
    static initProps(props) {
        // Adding an unload handler apparently forces Mithril to remove the element from the DOM
        props.onunload = () => {};
    }
}
